module.exports = __webpack_public_path__ + "img/alerts.08dd0290.svg";